import { render, staticRenderFns } from "./JourneyCases.vue?vue&type=template&id=11828671&scoped=true"
import script from "./JourneyCases.vue?vue&type=script&lang=js"
export * from "./JourneyCases.vue?vue&type=script&lang=js"
import style0 from "./JourneyCases.vue?vue&type=style&index=0&id=11828671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11828671",
  null
  
)

export default component.exports